import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const fetchSignupRequirementsDataModuleActions = createDataModuleActions(
    'FETCH_SIGNUP_REQUIREMENTS',
);
export const fetchSignupRequirementsForDataModule =
    fetchSignupRequirementsDataModuleActions.dataRequest;
export const fetchSignupRequirementsSuccess =
    fetchSignupRequirementsDataModuleActions.dataSuccess;
export const fetchSignupRequirementsError =
    fetchSignupRequirementsDataModuleActions.dataError;
export const fetchSignupRequirementsReset =
    fetchSignupRequirementsDataModuleActions.dataReset;
